import { render, staticRenderFns } from "./Suportar.vue?vue&type=template&id=ce2e57ca&"
import script from "./Suportar.vue?vue&type=script&lang=js&"
export * from "./Suportar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports